var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdcInfoTrustWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1949_736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.3379 54C32.2739 54 25.7129 47.439 25.7129 39.375C25.7129 31.311 32.2739 24.75 40.3379 24.75C48.4019 24.75 54.9629 31.311 54.9629 39.375C54.9629 47.439 48.4019 54 40.3379 54ZM40.3379 29.25C34.7556 29.25 30.2129 33.7928 30.2129 39.375C30.2129 44.9572 34.7556 49.5 40.3379 49.5C45.9201 49.5 50.4629 44.9572 50.4629 39.375C50.4629 33.7928 45.9201 29.25 40.3379 29.25ZM42.5856 43.5465L46.8291 39.4222C47.7201 38.556 47.7404 37.1318 46.8764 36.2407C46.0101 35.352 44.5859 35.3273 43.6949 36.1958L39.4379 40.3312C39.2151 40.5562 38.8484 40.5562 38.6234 40.3312L36.6524 38.4007C35.7636 37.5322 34.3416 37.548 33.4709 38.4368C32.6001 39.3255 32.6159 40.7475 33.5046 41.6182L35.4756 43.5487C36.4589 44.5117 37.7481 44.991 39.0351 44.991C40.3221 44.991 41.6136 44.5073 42.5879 43.5443L42.5856 43.5465ZM21.2129 27C13.7676 27 7.71289 20.9452 7.71289 13.5C7.71289 6.05475 13.7676 0 21.2129 0C28.6581 0 34.7129 6.05475 34.7129 13.5C34.7129 20.9452 28.6581 27 21.2129 27ZM21.2129 4.5C16.2494 4.5 12.2129 8.5365 12.2129 13.5C12.2129 18.4635 16.2494 22.5 21.2129 22.5C26.1764 22.5 30.2129 18.4635 30.2129 13.5C30.2129 8.5365 26.1764 4.5 21.2129 4.5ZM5.46289 51.75C5.46289 43.821 11.3871 37.1003 19.2419 36.1215C20.4749 35.9685 21.3501 34.8435 21.1971 33.6105C21.0441 32.3775 19.9056 31.5157 18.6861 31.6575C8.58139 32.9152 0.962891 41.5552 0.962891 51.75C0.962891 52.9943 1.97089 54 3.21289 54C4.45489 54 5.46289 52.9943 5.46289 51.75Z",
    fill: "#ffffff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1949_736",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "translate(0.962891)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdcInfoTrustWhite);
export default __webpack_public_path__ + "static/media/edc-info-trust-white.eddc2720ecd58dd4ed3fa40ab5d47d72.svg";
export { ForwardRef as ReactComponent };